import { useCallback } from 'react';
import type { CursorPaginationRailsParams } from 'common/services';
import type { EventsRequest } from '../../../services';
import type { EventsListFilter } from '../../../types';

export const useGetEventsParameters = () =>
  useCallback(
    ({
      filter,
      pagination,
    }: {
      filter?: Omit<EventsListFilter, 'organizationId' | 'scope'>;
      pagination?: CursorPaginationRailsParams;
    }): EventsRequest => ({
      community_id: filter?.communityId,
      cursor: pagination?.cursor,
      featured: filter?.featured,
      limit: pagination?.limit,
      pagination: filter?.pagination,
      rsvp: filter?.rsvp,
      start_time: {
        from: filter?.dateFrom?.toISOString(),
        to: filter?.dateTo?.toISOString(),
      },
      status: filter?.status,
      type: filter?.type,
    }),
    [],
  );
